import { lazy } from "react";

export const Login = lazy(() => import("./admin/login/login.route.tsx"));
export const EditCompany = lazy(
  () => import("./admin/dashboard/editCompany/editCompany.route.tsx")
);
export const Statistics = lazy(
  () => import("./admin/dashboard/contracts/contracts.route.tsx")
);
export const UserLogin = lazy(() => import("./login/login.route.tsx"));
export const Companies = lazy(
  () => import("./admin/dashboard/companies/companies.route.tsx")
);
export const BugTickets = lazy(
  () => import("./admin/dashboard/bugTickets/BugTickets.route.tsx")
);
export const TicketDetails = lazy(
  () =>
    import("./admin/dashboard/bugTickets/ticketDetails/TicketDetails.route.tsx")
);
export const FixedTickets = lazy(
  () =>
    import("./admin/dashboard/bugTickets/fixedTickets/FixedTickets.route.tsx")
);
export const UnderReviewingTickets = lazy(
  () =>
    import(
      "./admin/dashboard/bugTickets/underReviewingTickets/UnderReviewingTickets.route.tsx"
    )
);
export const NotFixedTickets = lazy(
  () =>
    import(
      "./admin/dashboard/bugTickets/notFixedTickets/NotFixedTickets.route.tsx"
    )
);
export const UserDashboard = lazy(
  () => import("./dashboard/dashboard.route.tsx")
);
export const SectorsRoute = lazy(
  () => import("./dashboard/sectors/sectors.route.tsx")
);
export const SegmentsRoute = lazy(
  () => import("./dashboard/segments/segments.route.tsx")
);
export const FileManager = lazy(
  () => import("./dashboard/fileManager/fileManager.route.tsx")
);
export const Qrcode = lazy(() => import("./dashboard/qrcode/qrcode.route.tsx"));
export const GuideBooks = lazy(
  () => import("./dashboard/guidebooks/guidebooks.route.tsx")
);
export const Reports = lazy(
  () => import("./dashboard/reports/reports.route.tsx")
);
export const ApprovalRequests = lazy(
  () => import("./dashboard/approvalRequests/approvalRequests.route.tsx")
);
export const Devices = lazy(
  () => import("./dashboard/devices/devices.route.tsx")
);
export const Staff = lazy(() => import("./dashboard/staff/staff.route.tsx"));
export const Attendance = lazy(
  () => import("./dashboard/attendance/attendance.route.tsx")
);
export const HomeLayout = lazy(
  () => import("./dashboard/homeLayout/homeLayout.route.tsx")
);
export const VehiclesGPS = lazy(
  () => import("./dashboard/vehiclesGPS/vehiclesGPS.route.tsx")
);
export const CCTV = lazy(() => import("./dashboard/cctv/cctv.component.tsx"));
export const StaffGPS = lazy(
  () => import("./dashboard/staffGPS/staffGPS.route.tsx")
);
export const NotFound = lazy(() => import("./notFound/NotFound.route.tsx"));
export const Sites = lazy(() => import("./dashboard/sites/sites.route.tsx"));
export const Providers = lazy(
  () => import("./dashboard/providers/providers.route.tsx")
);
export const AddQuestions = lazy(
  () => import("./dashboard/reports/addQuestions/addQuestions.route.tsx")
);
export const ThreeD = lazy(() => import("./dashboard/threeD/ThreeD.tsx"));
export const Users = lazy(() => import("./dashboard/users/Users.tsx"));
export const EmployeeCard = lazy(
  () => import("./dashboard/employeeCard/employeeCard.component.tsx")
);
export const Floors = lazy(() => import("./dashboard/floors/floors.route.tsx"));
export const AddPoint = lazy(() => import("./dashboard/addPoint/AddPoint.tsx"));
export const Version = lazy(
  () => import("./admin/dashboard/version/version.route.tsx")
);
export const Points = lazy(() => import("./dashboard/points/points.route.tsx"));
export const PointDraw = lazy(
  () => import("./dashboard/pointDraw/pointDraw.route.tsx")
);
export const Channels = lazy(
  () => import("./dashboard/channels/channels.route.tsx")
);
export const ReportsAnswers = lazy(
  () => import("./dashboard/reportsAnswers/reportsAnswers.route.tsx")
);
export const OperationPlanReport = lazy(
  () => import("./dashboard/operationPlanReport/operationPlanReport.route.tsx")
);
export const PointCard = lazy(
  () => import("./dashboard/pointCard/pointCard.route.tsx")
);
export const PointDesign = lazy(
  () => import("./dashboard/pointDesign/pointDesign.route.tsx")
);
export const StaffDesign = lazy(
  () => import("./dashboard/staffDesign/staffDesign.route.tsx")
);
export const Rooms = lazy(() => import("./dashboard/rooms/rooms.route.tsx"));
export const Assets = lazy(() => import("./dashboard/assets/assets.route.tsx"));
export const ChannelUsers = lazy(
  () => import("./dashboard/channelUsers/channelUsers.route.tsx")
);
export const Groups = lazy(() => import("./dashboard/groups/groups.route.tsx"));
export const GroupUsers = lazy(
  () => import("./dashboard/groupUsers/groupUsers.route.tsx")
);
export const StaffGPSUsers = lazy(
  () => import("./dashboard/StaffGPSUsers/StaffGPSUsers.route.tsx")
);
export const Services = lazy(
  () => import("./admin/dashboard/services/services.route.tsx")
);
export const Qrcard = lazy(() => import("./dashboard/qrcard/qrcard.route.tsx"));
export const Blacklist = lazy(
  () => import("./dashboard/blacklist/Blacklist.route.tsx")
);
export const ClientStatistics = lazy(
  () => import("./dashboard/clientStatistics/clientStatistics.route.tsx")
);
export const QrCardColors = lazy(
  () => import("./dashboard/qrcardColors/qrcardColors.route.tsx")
);
export const ChannelHistory = lazy(
  () => import("./dashboard/channelHistory/ChannelHistory.route.tsx")
);
export const GroupChats = lazy(
  () => import("./dashboard/GroupChats/GroupChats.route.tsx")
);
export const PrivateChats = lazy(
  () => import("./dashboard/privateChats/privateChats.route.tsx")
);
export const SinglePrivateChat = lazy(
  () => import("./dashboard/singlePrivateChat/singlePrivateChat.route.tsx")
);
export const StructurePoints = lazy(
  () => import("./dashboard/structurePoints/structurePoints.route.tsx")
);
export const AssetTypes = lazy(
  () => import("./dashboard/assetTypes/assetTypes.route.tsx")
);
export const AssetsCards = lazy(
  () => import("./dashboard/AssetsCards/AssetsCards.route.tsx")
);
export const AssetsDesign = lazy(
  () => import("./dashboard/assetsDesign/AssetsDesign.route.tsx")
);
export const StaffGPSUsersEditMap = lazy(
  () => import("./dashboard/StaffGPSUsersEditMap/StaffGPSUsersEditMap.route")
);

export const Profile = lazy(() => import("./dashboard/profile/Profile.route"));

export const OperationPlan = lazy(() => import("./dashboard/operationPlan/OperationPlan.route.tsx"));

export const OperationPlanPoints = lazy(() => import("./dashboard/operationPlanPoints/OperationPlanPoints.route.tsx"));

export const OperationPlanTasks = lazy(() => import("./dashboard/operationPlanTasks/OperationPlanTasks.route.tsx"));

// export const RoomReservations = lazy(
//   () => import("./dashboard/roomReservations/RoomReservations.route.tsx")
// );

// export const RoomsReservation = lazy(
//   () => import("./rooms/roomsReservation/RoomsReservation.tsx")
// );
// export const RoomDetails = lazy(
//   () => import("./rooms/roomDetails/RoomDetails.tsx")
// );

const ConditionalRoute = lazy(() => import("./ConditionalRoute.component"));
const StructureAssets = lazy(
  () => import("./dashboard/structureAssets/structureAssets.route")
);
const StockingAssets = lazy(
  () => import("./dashboard/stockingAssets/stockingAssets.route")
);
const StructureStockingAssets = lazy(
  () =>
    import("./dashboard/structureStockingAssets/structureStockingAssets.route")
);
const AnswerReport = lazy(
  () => import("./dashboard/answerReport/AnswerReport.route")
);
const RoomsReservation = lazy(
  () => import("./rooms/roomsReservation/RoomsReservation")
);
const RoomDetails = lazy(() => import("./rooms/roomDetails/RoomDetails"));
const ReservationRequests = lazy(
  () => import("./dashboard/reservationRequests/ReservationRequests")
);
const ReservationStatus = lazy(
  () => import("./rooms/reservationStatus/ReservationStatus")
);
const Home = lazy(() => import("./portfolio/home/Home.route"));
const OurWork = lazy(() => import("./portfolio/ourWork/OurWork.route"));
const AboutUs = lazy(() => import("./portfolio/aboutUs/AboutUs.route"));
const ContactUs = lazy(() => import("./portfolio/contactUs/ContactUs.route"));
const RoomReservations = lazy(
  () => import("./dashboard/roomReservations/RoomReservations.route")
);
const AllReservations = lazy(
  () => import("./dashboard/allReservations/AllReservations.route")
);
const DepartmentsRoute = lazy(
  () => import("./dashboard/departments/Departments.route")
);
const ShiftsRoute = lazy(() => import("./dashboard/shifts/Shifts.route"));
const JobRolesRoute = lazy(
  () => import("./dashboard/jobRoles/JobRoles.route.tsx")
);
const PrivateChatsHistory = lazy(
  () => import("./dashboard/privateChatHistory/PrivateChatsHistory")
);
const SinglePrivateChatUser = lazy(
  () =>
    import(
      "./dashboard/singlePrivateChatUser.route.tsx/SinglePrivateChatUser.route"
    )
);
const DepartmentsShiftsRoute = lazy(
  () => import("./dashboard/departmentsShifts/DepartmentsShifts.route")
);
const DepartmentsShiftUsersRoute = lazy(
  () => import("./dashboard/departmentsShiftUsers/DepartmentsShiftUsers.route")
);
const ContactPerson = lazy(
  () => import("./dashboard/contactPerson/ContactPerson.route")
);
const GeneralProfile = lazy(
  () => import("./dashboard/profile/GeneralProfile.route")
);
const StaffOutOfLocation = lazy(
  () => import("./dashboard/StaffOutOfLocation/StaffOutOfLocation.route")
);
const ChangePassword = lazy(
  () => import("./dashboard/profile/ChangePassword.route")
);
const MyPermissions = lazy(
  () => import("./dashboard/myPermissions/MyPermissions.route.tsx")
);
const VisitorsBlackList = lazy(
  () => import("./dashboard/visitorsBlackList/VisitorsBlackList.route.tsx")
);
const PublicSettings = lazy(
  () => import("./dashboard/publicSettings/PublicSettings.route")
);
const Transaction = lazy(
  () => import("./dashboard/transaction/Transaction.route.tsx")
);
const TransactionContainers = lazy(
  () =>
    import("./dashboard/transactionContainers/TransactionContainers.route.tsx")
);

const TransactionContainersCategories = lazy(
  () =>
    import(
      "./dashboard/transactionContainersCategories/TransactionContainersCategories.route.tsx"
    )
);
const TransactionStatus = lazy(
  () => import("./dashboard/transactionStatus/TransactionStatus.route.tsx")
);
const TransactionStatusCategories = lazy(
  () =>
    import(
      "./dashboard/transactionStatusCategories/TransactionStatusCategories.route.tsx"
    )
);
const TransactionContainerLocations = lazy(
  () =>
    import(
      "./dashboard/transactionContainerLocations/TransactionContainerLocations.route.tsx"
    )
);
const DrugsTest = lazy(
  () => import("./dashboard/drugsTest/DrugsTest.route.tsx")
);

const Admins = lazy(() => import("./admin/dashboard/admins/Admins.route.tsx"));
const Countries = lazy(() => import("./admin/dashboard/countries/Countries.route.tsx"));
const Holidays = lazy(() => import("./admin/dashboard/holidays/Holidays.route.tsx"));

const DrugTestResult = lazy(
  () => import("./dashboard/drugTestResult/DrugTestResult.route")
);

const Courses = lazy(() => import("./dashboard/courses/Courses.route"));
const CoursesCategory = lazy(
  () => import("./dashboard/coursesCategory/CoursesCategory.route.tsx")
);

const ActivityLog = lazy(
  () => import("./dashboard/activityLog/ActivityLog.route.tsx")
);
const ActivityLogUser = lazy(
  () => import("./dashboard/activityLogUser/ActivityLogUser.route.tsx")
);
const ActivityLogTabBar = lazy(
  () => import("./dashboard/activityLogTabBar/ActivityLogTabBar.tsx")
);

const DeletedUsers = lazy(
  () => import("./dashboard/deletedUsers/DeletedUsers.route.tsx")
);
const DeletedStaff = lazy(
  () => import("./dashboard/deletedStaff/DeletedStaff.route.tsx")
);
const DeletedShifts = lazy(
  () => import("./dashboard/deletedShifts/DeletedShifts.route.tsx")
);
const DeletedStaffBlackList = lazy(
  () =>
    import("./dashboard/deletedStaffBlackList/DeletedStaffBlackList.route.tsx")
);

const DeletedAssetTypes = lazy(
  () => import("./dashboard/deletedAssetTypes/DeletedAssetTypes.route.tsx")
);

export const DeletedSegments = lazy(
  () => import("./dashboard/deletedSegments/DeletedSegments.route.tsx")
);

const DeletedSectors = lazy(
  () => import("./dashboard/deletedSectors/DeletedSectors.route.tsx")
);

const DeletedSites = lazy(
  () => import("./dashboard/deletedSites/DeletedSites.route.tsx")
);
const DeletedServiceProviders = lazy(
  () =>
    import(
      "./dashboard/deletedServiceProviders/DeletedServiceProviders.route.tsx"
    )
);
const DeletedFloors = lazy(
  () => import("./dashboard/deletedFloors/DeletedFloors.route.tsx")
);
const DeletedPoints = lazy(
  () => import("./dashboard/deletedPoints/DeletedPoints.route.tsx")
);
const DeletedRooms = lazy(
  () => import("./dashboard/deletedRooms/DeletedRooms.route.tsx")
);
const DeletedAssets = lazy(
  () => import("./dashboard/deletedAssets/DeletedAssets.route.tsx")
);
const DeletedChannels = lazy(
  () => import("./dashboard/deletedChannels/DeletedChannels.route.tsx")
);
const DeletedGroups = lazy(
  () => import("./dashboard/deletedGroups/DeletedGroups.route.tsx")
);
const DeletedContactPerson = lazy(
  () =>
    import("./dashboard/deletedContactPerson/DeletedContactPerson.route.tsx")
);
const DeletedReports = lazy(
  () => import("./dashboard/deletedReports/DeletedReports.route.tsx")
);
const DeletedQrcard = lazy(
  () => import("./dashboard/deletedQrcard/DeletedQrcard.route.tsx")
);
const DeletedDevices = lazy(
  () => import("./dashboard/deletedDevices/DeletedDevices.route.tsx")
);
const DeletedDrugsTest = lazy(
  () => import("./dashboard/deletedDrugsTest/DeletedDrugsTest.route.tsx")
);
const DeletedCourses = lazy(
  () => import("./dashboard/deletedCourses/DeletedCourses.route.tsx")
);

const DeletedDepartments = lazy(
  () => import("./dashboard/deletedDepratments/DeletedDepartments.route.tsx")
);

const ClientQrCodeRedirct = lazy(
  () => import("./ClientQrCodeRedirct/ClientQrCodeRedirct.route.tsx")
);
const LateRequestsAttendance = lazy(
  () =>
    import(
      "./dashboard/lateRequestsAttendance/LateRequestsAttendance.route.tsx"
    )
);

const WorkingActivity = lazy(
  () => import("./dashboard/workingActivity/WorkingActivity.route.tsx")
);
const VacationRequestTypes = lazy(
  () =>
    import("./dashboard/vacationRequestTypes/VacationRequestTypes.route.tsx")
);

const VacationRequests = lazy(
  () => import("./dashboard/vacationRequests/VacationRequests.route.tsx")
);
const OvertimeRequests = lazy(
  () => import("./dashboard/overtimeRequests/OvertimeRequests.route.tsx")
);

const StaffSalary = lazy(
  () => import("./dashboard/staffSalary/StaffSalary.route.tsx")
);

const salaryRecord = lazy(
  () => import("./dashboard/salaryRecord/SalaryRecord.route.tsx")
);

const DeletedStaffSalary = lazy(
  () => import("./dashboard/deletedStaffSalary/DeletedStaffSalary.route.tsx")
);

const DeletedSalaryRecord = lazy(
  () => import("./dashboard/deletedSalaryRecord/DeletedSalaryRecord.route.tsx")
);

const Buffet = lazy(() => import("./dashboard/buffet/Buffet.route.tsx"));

const DeletedBuffet = lazy(
  () => import("./dashboard/deletedBuffets/DeletedBuffets.route.tsx")
);

const BuffetProducts = lazy(
  () => import("./dashboard/buffetProducts/BuffetProducts.route.tsx")
);

const QrcardDesign = lazy(
  () => import("./dashboard/qrcardDesgin/QrcardDesign.route.tsx")
);

const OrderBuffet = lazy(
  () => import("./dashboard/orderBuffet/OrderBuffet.route.tsx")
);
const RequestVacation = lazy(
  () => import("./dashboard/requestVacation/RequestVacation.route.tsx")
);

const RequestOvertime = lazy(
  () => import("./dashboard/requestOvertime/RequestOvertime.route.tsx")
);

const MyBuffetOrders = lazy(
  () => import("./dashboard/myBuffetOrders/MyBuffetOrders.route.tsx")
);

const BuffetOrdersHistory = lazy(
  () => import("./dashboard/buffetOrdersHistory/BuffetOrdersHistory.route.tsx")
);

const BuffetOrders = lazy(
  () => import("./dashboard/buffetOrders/BuffetOrders.route.tsx")
);

const DeletedBuffetOrders = lazy(
  () => import("./dashboard/deletedBuffetOrders/DeletedBuffetOrders.route.tsx")
);

const BuffetGroups = lazy(
  () => import("./dashboard/buffetGroups/BuffetGroups.route.tsx")
);

const DeletedBuffetGroups = lazy(
  () =>
    import("./dashboard/deletedBuffetsGroups/DeletedBuffetsGroups.route.tsx")
);
const SendTicket = lazy(
  () => import("./dashboard/sendTicket/sendTicket.route.tsx")
);
const Tickets = lazy(() => import("./dashboard/tickets/Tickets.route.tsx"));
const TicketsDetails = lazy(
  () => import("./dashboard/ticketDetails/TicketDetails.route.tsx")
);
const TicketsSettings = lazy(
  () => import("./dashboard/ticketsSettings/TicketsSettings.route.tsx")
);
const MyTickets = lazy(
  () => import("./dashboard/myTickets/MyTickets.route.tsx")
);
const Subscriptions = lazy(
  () => import("./admin/dashboard/subscriptions/subscriptions.route.tsx")
);
const MinutesOfMeetings = lazy(
  () => import("./dashboard/minutesOfMeetings/MinutesOfMeetings.route.tsx")
);
const Meetings = lazy(
  () => import("./dashboard/minutesOfMeetings/meetings/Meetings.route.tsx")
);
const Minutes = lazy(
  () => import("./dashboard/minutesOfMeetings/minutes/Minutes.route.tsx")
);
const Agendas = lazy(
  () => import("./dashboard/minutesOfMeetings/agendas/Agendas.route.tsx")
);
const AttendeeUsers = lazy(
  () =>
    import(
      "./dashboard/minutesOfMeetings/attendeeUsers/AttendeeUsers.route.tsx"
    )
);
const Tasks = lazy(
  () => import("./dashboard/minutesOfMeetings/tasks/Tasks.route.tsx")
);
const SOSHistory = lazy(() => import("./dashboard/sosHistory/SOSHistory.route.tsx"))
const SOSHistoryVideos = lazy(() => import("./dashboard/sosHistoryVideos/sosHistoryVideos.tsx"))
const WalkieTalkieHistory = lazy(() => import("./dashboard/WalkieTalkieHistory/WalkieTalkieHistory.route.tsx"))
const NewReportForm = lazy(() => import("./dashboard/reportsAnswers/reportsForm/newReportForm.tsx"))
const EyeStatistics = lazy(() => import("./dashboard/EyeStatistics/EyeStatistics.route.tsx"))
const FMStatistics = lazy(() => import("./dashboard/FMStatistics/FMStatistics.route.tsx"))
const FTEStatistics = lazy(() => import("./dashboard/FTEStatistics/FTEStatistics.route.tsx"))

export {
  ConditionalRoute,
  StructureAssets,
  StockingAssets,
  StructureStockingAssets,
  AnswerReport,
  RoomsReservation,
  RoomDetails,
  ReservationRequests,
  ReservationStatus,
  Home,
  OurWork,
  AboutUs,
  ContactUs,
  RoomReservations,
  AllReservations,
  DepartmentsRoute,
  ShiftsRoute,
  JobRolesRoute,
  PrivateChatsHistory,
  SinglePrivateChatUser,
  DepartmentsShiftsRoute,
  DepartmentsShiftUsersRoute,
  ContactPerson,
  GeneralProfile,
  StaffOutOfLocation,
  ChangePassword,
  MyPermissions,
  VisitorsBlackList,
  PublicSettings,
  Transaction,
  TransactionContainers,
  TransactionContainersCategories,
  TransactionStatus,
  TransactionStatusCategories,
  TransactionContainerLocations,
  DrugsTest,
  DrugTestResult,
  Admins,
  Countries,
  Holidays,
  Courses,
  CoursesCategory,
  ActivityLog,
  DeletedUsers,
  DeletedStaff,
  DeletedShifts,
  DeletedStaffBlackList,
  DeletedAssetTypes,
  DeletedSectors,
  DeletedSites,
  DeletedServiceProviders,
  DeletedFloors,
  DeletedPoints,
  DeletedRooms,
  DeletedAssets,
  DeletedChannels,
  DeletedGroups,
  DeletedContactPerson,
  DeletedReports,
  DeletedQrcard,
  DeletedDevices,
  DeletedDrugsTest,
  DeletedCourses,
  DeletedDepartments,
  ClientQrCodeRedirct,
  LateRequestsAttendance,
  ActivityLogUser,
  ActivityLogTabBar,
  WorkingActivity,
  VacationRequestTypes,
  VacationRequests,
  OvertimeRequests,
  StaffSalary,
  salaryRecord,
  DeletedStaffSalary,
  DeletedSalaryRecord,
  Buffet,
  DeletedBuffet,
  BuffetProducts,
  QrcardDesign,
  OrderBuffet,
  RequestVacation,
  RequestOvertime,
  MyBuffetOrders,
  BuffetOrdersHistory,
  BuffetOrders,
  BuffetGroups,
  DeletedBuffetOrders,
  DeletedBuffetGroups,
  SendTicket,
  Tickets,
  TicketsDetails,
  TicketsSettings,
  MyTickets,
  Subscriptions,
  MinutesOfMeetings,
  Meetings,
  Minutes,
  Agendas,
  AttendeeUsers,
  Tasks,
  SOSHistory,
  SOSHistoryVideos,
  WalkieTalkieHistory,
  NewReportForm,
  EyeStatistics,
  FMStatistics,
  FTEStatistics,
};
